import React from "react";
import { Form, Input, Button } from "antd";

const FormOriginal = props => {
  const { getFieldDecorator } = props.form;

  getFieldDecorator("keys", {
    initialValue: props.defaultValues
  });

  return (
    <div
      style={{
        width: "500px",
        display: "block",
        margin: "0 auto",
        padding: "20px 20px 20px 20px",
        background: "#eee",
        borderWidth: "2px",
        borderRadius: "20px"
      }}
    >
      <div
        style={{
          alignItems: "center",
          justifyContent: "center",
          display: "flex"
        }}
      >
        <Form
          onSubmit={e => props.handleSubmit(e, props.form)}
          className="login-form"
          style={{ width: "100%" }}
        >
          <Form.Item label="Component Input">
            {getFieldDecorator("name", {
              initialValue: props.defaultValues && props.defaultValues.name,
              rules: [
                {
                  required: true,
                  message: "Please input your component input name!"
                }
              ]
            })(<Input placeholder="Component Input" className="antInput" />)}
          </Form.Item>
          <Form.Item label="type">
            {getFieldDecorator("type", {
              initialValue: props.defaultValues && props.defaultValues.type,

              rules: [
                {
                  required: true,
                  message: "Please input your component description!"
                }
              ]
            })(<Input placeholder="Type" className="antInput" />)}
          </Form.Item>
          <Form.Item label="Label">
            {getFieldDecorator("label", {
              initialValue: props.defaultValues && props.defaultValues.label,

              rules: [
                {
                  required: true,
                  message: "Please input your component label!"
                }
              ]
            })(<Input placeholder="label" className="antInput" />)}
          </Form.Item>
          <Form.Item label="Active Code">
            {getFieldDecorator("activeCode", {
              initialValue:
                props.defaultValues && props.defaultValues.activeCode,

              rules: [
                {
                  required: true,
                  message: "Please input your product company logo!"
                }
              ]
            })(<Input placeholder="active code" className="antInput" />)}
          </Form.Item>
          <Form.Item label="deactive Code">
            {getFieldDecorator("deactiveCode", {
              initialValue:
                props.defaultValues && props.defaultValues.deactiveCode,

              rules: [
                {
                  required: true,
                  message: "Please input your product company logo!"
                }
              ]
            })(<Input placeholder="deactive code" className="antInput" />)}
          </Form.Item>
          <Form.Item label="Motor Speed">
            {getFieldDecorator("speed", {
              initialValue: props.defaultValues && props.defaultValues.speed
            })(<Input placeholder="motor speed" className="antInput" />)}
          </Form.Item>

          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              {props.type} Components
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};
const WrappedNormalLoginForm = Form.create({ name: "ComponentsCreate" })(
  FormOriginal
);

export default WrappedNormalLoginForm;
